import React from 'react';
import { useSelector } from 'react-redux';

import EditorMoreDropdown from '../../../../pages/contentOptimizer/contentPage/content/optimizerTab/tiptapEditor/moreDropdown/EditorMoreDropdown';
import EditorToolbar from '../EditorToolbar';
import OptimizerEditorToolbarSections from './OptimizerEditorToolbarSections';
import OptimizerVersionHistory from './OptimizerVersionHistory';

import { selectAIStateLoading } from '../../store/tiptapEditor.selectors';

import { useIsAIContentGeneration } from '../../../../../utils/hooks/useIsAIContentGeneration';

const OptimizerEditorToolbar = () => {
    const aiLoading = useSelector(selectAIStateLoading);
    const { isAIContentGeneration } = useIsAIContentGeneration();

    return (
        <EditorToolbar
            toolbarSections={<OptimizerEditorToolbarSections />}
            versionHistorySection={<OptimizerVersionHistory />}
            moreDropdown={<EditorMoreDropdown disabled={aiLoading || isAIContentGeneration} />}
        />
    );
};

export default OptimizerEditorToolbar;
